import { gql } from "@apollo/client";
import axios from "axios";
import {
  ForgetPasswordApiService,
  MCBSwitchService,
  loginUrl,
} from "../config";
const base_url = loginUrl.login;
const getAuthHeaders = () => {
  const token = localStorage.getItem("token");
  const formattedToken = `Bearer ${token?.replace(/"/g, "")}`;

  return {
    Authorization: formattedToken,
    "Content-Type": "application/json",
  };
};
export const GET_USERS = gql`
  query {
    allUsersView {
      id
      firstName
      username
      lastName
      idno
      phone
      email
      isActive
      role
      roleGroup
      roleId
      genderId
      regionId
      branchId
      branchName
    }
  }`;

export const CREATE_USER = gql`
  mutation CreateUser(
    $firstName: String!
    $lastName: String!
    $email: String!
    $phone: String!
    $username: String!
    $idno: String!
    $roleId: Int!
    $createdBy: Int!
    $roleName: String
  ) {
    createUser(
      user: {
        firstName: $firstName
        lastName: $lastName
        email: $email
        phone: $phone
        username: $username
        idno: $idno
        roleId: $roleId
        roleName: $roleName
        createdBy: $createdBy
      }
    ) {
      id
      firstName
      lastName
      email
      phone
      username
      idno
      roleId
      roleName
      createdBy
      createdDate
    }
  }
`;

export const UPDATE_USER = gql`
  mutation editUser(
    $id: Int!
    $firstName: String!
    $lastName: String!
    $email: String!
    $phone: String!
    $username: String!
    $idno: String!
    $roleId: Int!
    $createdBy: Int!
    $roleName: String
  ) {
    editUser(
      user: {
        id: $id
        firstName: $firstName
        lastName: $lastName
        email: $email
        phone: $phone
        username: $username
        idno: $idno
        roleId: $roleId
        roleName: $roleName
        createdBy: $createdBy
      }
    ) {
      id
      firstName
      lastName
      email
      phone
      username
      idno
      roleId
      roleName
      createdBy
      createdDate
    }
  }
`;
export const CHANGE_PASSWORD = gql`
  mutation ChangePassword(
    $identifier: String!
    $password: String!
    $oldPassword: String!
  ) {
    changePassword(
      identifier: $identifier
      password: $password
      oldPassword: $oldPassword
    ) {
        isValid
        failReason
    }
  }
`;
export const RESET_PASSWORD = gql`
  mutation ResetPassword($userid: Int!) {
    resetPassword(userid: $userid) {
      id
    }
  }
`;
// export const ACTIVATE_USER = gql`
//   mutation DeactivateUser($id: Int!) {
//     deactivateUser(user: { id: $id })
//   }
// `;

export const ACTIVATE_DEACTIVATE_USER = gql`
  mutation ActivateDeactivateUser($id: Int!, $isActive: Boolean!) {
    activateDeactivateUser(userId: $id, isActive: $isActive)
  }
`;

export const ACTIVATE_USER = gql`
  mutation ActivateUser($id: Int!) {
    activateUser(user: { id: $id })
  }
`;

export const DEACTIVATE_USER = gql`
  mutation DeactivateUser($id: Int!) {
    deactivateUser(user: { id: $id })
  }
`;
export async function loginCallApi(username, HashedPassword) {
  const postData = {
    username,
    HashedPassword,
  };

  try {
    const response = await axios.post(base_url, postData);
    return response;
  } catch (error) {
    return error;
  }
}
export async function ForgetPasswordApi(email) {
  const postData = {
    email,
  };

  try {
    const response = await axios.post(ForgetPasswordApiService.uri, postData);
    return response;
  } catch (error) {
    return error.code;
  }
}
export async function MCBSwitchCallApi(id) {
  const headers = getAuthHeaders();
  const postData = {
    id,
  };

  try {
    const response = await axios.post(MCBSwitchService.uri, postData, {
      headers,
    });
    return response;
  } catch (error) {
    return error.code;
  }
}

export async function MCBSwitchCallApiPos(id, region, branch) {
  const headers = getAuthHeaders();
  let postData;

  if (
    id !== null &&
    id !== "" &&
    region !== null &&
    region !== "" &&
    branch !== null &&
    branch !== ""
  ) {
    postData = {
      company: { Id: id },
      region: { Id: region },
      branch: { Id: branch },
    };
  } else if (
    (region === null || region === "") &&
    (branch === null || branch === "")
  ) {
    postData = {
      company: { Id: id },
    };
  } else if (
    (region !== null || region !== "") &&
    (branch === null || branch === "")
  ) {
    postData = {
      company: { Id: id },
      region: { Id: region },
    };
  } else {
    postData = {
      company: { Id: id },
      region: { Id: region },
      branch: { Id: branch },
    };
  }

  try {
    const response = await axios.post(MCBSwitchService.uri, postData, {
      headers,
    });
    return response;
  } catch (error) {
    return error.code;
  }
}
